import { FC, ReactNode } from 'react';

import style from './index.module.css';

// 配列内要素が存在しない場合の表示
export const NothingItem: FC<{
  type: ItemType
}> = ({ type }) => {

  const text: ReactNode = (() => {
    switch(type) {
      case 'recommend': return '現在、おすすめの商品はありません。';
      case 'paused': return '現在、停止中の商品はありません。';
      case 'registered': return '現在、お届け予定の商品はありません。';
      case 'presale': return <>
        現在、先行予約商品はありません。<br/>
        突然追加される場合もあるので、定期的にチェックしてください。
      </>;
      default: return '';
    }

  })();

  return type === '' ? (
    <></>
  ) : (
    <p className={style.nothingItem}>{ text }</p>
  );
}

type ItemType = 'recommend' | 'paused' | 'registered' | 'presale' | '';